import React, { useEffect } from "react";
import { getDatabase, ref, onValue, update } from "firebase/database";
import "./NovelSummary.css"; // Importing a CSS file for styling

const NovelSummary = () => {
  const db = getDatabase();
  const [formData, setFormData] = React.useState({
    novelTitle: "",
    novelSummary: "",
  });

  useEffect(() => {
    const novelRef = ref(db, "jambNovelSummary");
    onValue(novelRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setFormData(data);
      }
    });
  }, [db]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const novelRef = ref(db, "jambNovelSummary");
      await update(novelRef, formData);
      alert("Novel data updated successfully.");
    } catch (error) {
      console.error("Error updating novel data:", error);
      alert("Failed to update novel data.");
    }
  };

  return (
    <div className="novel-summary-container">
      <h1 className="novel-summary-title">Novel Summary</h1>
      <form className="novel-summary-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="novelTitle" className="form-label">
            Novel Title
          </label>
          <input
            id="novelTitle"
            type="text"
            name="novelTitle"
            className="form-input"
            value={formData.title || ""}
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="novelSummary" className="form-label">
            Novel Summary
          </label>
          <textarea
            id="novelSummary"
            name="novelSummary"
            className="form-textarea"
            value={formData.summary || ""}
            onChange={(e) =>
              setFormData({ ...formData, summary: e.target.value })
            }
          />
        </div>
        <button type="submit" className="form-button">
          Save
        </button>
      </form>
    </div>
  );
};

export default NovelSummary;
